const Url = {
    fetchUrl:function(url){
        let projectsURL = process.env.REACT_APP_ORIGIN_URL || "https://origin.kforcontact.com";
        return projectsURL;
    }
  }
      
   export default Url;